import BillingAddress from './BillingAddress'

export default BillingAddress
